'use client';

import { Box, SxProps } from '@mui/material';
import { PORTAL_USE_TYPE, isPortalUseType } from '@/types/types';
import { useSearchParams } from 'next/navigation';
import { SigninForm } from './SigninForm';
import { getToken } from '@/helpers/apiRequestHelper';
import { useEffect } from 'react';
import { signOut } from 'next-auth/react';

export function SigninBox() {
  const searchParams = useSearchParams();
  const useTypeParam = parseInt(searchParams.get('use_type') || '2');
  const defaultSelected = isPortalUseType(useTypeParam)
    ? useTypeParam
    : PORTAL_USE_TYPE.REQUEST_USER;

  const TabContentStyle: SxProps = {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    width: '100%',
  };

  useEffect(() => {
    const checkToken = async () => {
      const token = await getToken();
      if (!token) {
        await signOut({ redirect: false });
      }
    };
    checkToken();
  }, []);

  return (
    <Box
      width="100%"
      minHeight="574px"
      maxHeight="100%"
      display="flex"
      flexDirection="column"
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexGrow={1}
      >
        <Box width="90%" maxWidth="450px" mt={6}>
          <Box sx={TabContentStyle}>
            <SigninForm useType={defaultSelected as PORTAL_USE_TYPE} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
